import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { generateArrayOfYears } from '../../../Constants/config'
import { getDaysArray } from '../../../Constants/generateDate'
import { months } from '../../../Constants/formatMonth'
import Loading from '../../loading'

const InnerScrollPickerStyled = styled.div`
  background: #FFFFFF;
  position: relative;

  li {
    list-style: none;
  }

  .picker-window {
    position: absolute;
    height: 1.4em;
    left: 0;
    top: 50%;
    transform: translateY(-82%);
    width: 100%;
    pointer-events: none;
  }

  .triangle {
    content: "";
    background: white;
    height: 20px;
    width: 20px;
    position: absolute;
    display: block;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }

  .picker {
    display: inline-grid;
    box-shadow: 0 0.5vw 2vw -5px rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    position: relative;
    border-top: 7px solid white;
    background: white;
    grid-template-columns: repeat(5, fit-content(500px));
    -webkit-overflow-scrolling: touch;
    font-feature-settings: "tnum";
    width: 100%;
  }

  .picker:before, .picker:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2em;
    pointer-events: none;
  }

  .picker:before {
    top: 0;
    background: linear-gradient(white, rgba(255, 255, 255, 0.7));
  }

  .picker:after {
    bottom: 15px;
    background: linear-gradient(rgba(255, 255, 255, 0.7), white);
  }

  li {
    user-select: none;
  }

  .picker ul {
    -ms-overflow-style: none;
    max-height: 90px;
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
    padding: 30px 8px;
  }

  .picker ul::-webkit-scrollbar {
    display: none;
  }

  .picker li {
    scroll-snap-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 30px;
    text-align: right;
    word-spacing: 0.2em;
    color: ${({ theme }) => theme.black};
  }

  .picker-day {
    padding-right: 0.5em;
  }

  .picker-day span {
    padding-left: 0.5em;
  }

  .picker ul.picker-minute {
    padding-left: 0;
  }
`

const Title = styled.div`
  display: grid;
  padding-left: 3px;
  padding-right: 3px;
  grid-template-columns: repeat(4, 1fr);
  justify-content: center;

  .item {
    border-bottom: 1px solid ${({ theme }) => theme.black};
    padding: 5px;
    color: ${({ theme }) => theme.black};

    font-weight: 700;
    font-size: 12px;

  }
`

// eslint-disable-next-line react/prop-types
const InnerScrollPicker = ({ setDateSubmit }) => {
  const { t } = useTranslation('common')
  const [year, setYear] = useState(new Date().getFullYear().toString())
  const [month, setMonth] = useState(1)
  const [date, setDate] = useState(1)
  const [hour, setHour] = useState('00')
  const [minute, setMinute] = useState('00')
  const [isLoading, setIsLoading] = useState(false)
  const debounce = _.debounce(({ data, type }) => {
    switch (type) {
      case 'year':
        setYear(data)
        break
      case 'month':
        setMonth(months[data])
        break
      case 'date':
        setDate(data)
        break
      case 'hour':
        setHour(data)
        break
      case 'minute':
        setMinute(data)
        break
      default:
        break
    }
    setIsLoading(false)
  }, 500, ['result'])

  function scrollHandlerYear() {
    const container = document.querySelector('.picker-year')
    new Array(51).slice.call(container.children).forEach((ele) => {
      if (Math.abs(ele.getBoundingClientRect().top - container.getBoundingClientRect().top) < 50) {
        debounce({ data: ele.innerText, type: 'year' })
        setIsLoading(true)
      }
    })
  }

  function scrollHandlerMonth() {
    const container = document.querySelector('.picker-month')
    new Array(51).slice.call(container.children).forEach((ele) => {
      if (Math.abs(ele.getBoundingClientRect().top - container.getBoundingClientRect().top) < 50) {
        debounce({ data: ele.innerText, type: 'month' })
        setIsLoading(true)
      }
    })
  }

  function scrollHandlerDate() {
    const container = document.querySelector('.picker-date')
    new Array(51).slice.call(container.children).forEach((ele) => {
      if (Math.abs(ele.getBoundingClientRect().top - container.getBoundingClientRect().top) < 50) {
        debounce({ data: ele.getAttribute('data-date-type'), type: 'date' })
        setIsLoading(true)
      }
    })
  }

  function scrollHandlerHour() {
    const container = document.querySelector('.picker-hour')
    new Array(51).slice.call(container.children).forEach((ele) => {
      if (Math.abs(ele.getBoundingClientRect().top - container.getBoundingClientRect().top) < 50) {
        debounce({ data: ele.innerText, type: 'hour' })
        setIsLoading(true)
      }
    })
  }

  function scrollHandlerMinute() {
    const container = document.querySelector('.picker-minute')
    new Array(51).slice.call(container.children).forEach((ele) => {
      if (Math.abs(ele.getBoundingClientRect().top - container.getBoundingClientRect().top) < 50) {
        debounce({ data: ele.innerText, type: 'minute' })
        setIsLoading(true)
      }
    })
  }

  useEffect(() => {
    const dateResult = `${year}/${month}/${date || date.attribute} ${hour}:${minute}`
    setDateSubmit(dateResult)
  }, [year,
    month,
    date,
    hour,
    minute])
  useEffect(() => {
    document.querySelector('.picker-year')
      .addEventListener('scroll', (e) => scrollHandlerYear(e))
    document.querySelector('.picker-month')
      .addEventListener('scroll', (e) => scrollHandlerMonth(e))
    document.querySelector('.picker-date')
      .addEventListener('scroll', (e) => scrollHandlerDate(e))
    document.querySelector('.picker-hour')
      .addEventListener('scroll', (e) => scrollHandlerHour(e))
    document.querySelector('.picker-minute')
      .addEventListener('scroll', (e) => scrollHandlerMinute(e))
  }, [])

  const renderYear = () => (
    <ul className="picker-year" id="picker-year">
      {generateArrayOfYears().map((yearItem, index) => <li key={index}>{yearItem}</li>)}
    </ul>
  )

  const renderMonth = () => (
    <ul className="picker-month">
      {
        moment.months().map((monthItem, index) => <li key={index}>{monthItem}</li>)
      }
    </ul>
  )

  const renderDate = () => (
    <ul className="picker-date">
      {
        getDaysArray(year, month, t).map((dateItem, index) => (
          <li
            data-date-type={dateItem.attribute}
            key={index}
          >
            {dateItem.data}
          </li>
        ))
      }
    </ul>
  )
  return (
    <InnerScrollPickerStyled>
      {isLoading && <Loading loadingMini />}
      <Title>
        <div className="item">Year</div>
        <div className="item">Month</div>
        <div className="item">Day</div>
        <div className="item">Time</div>
      </Title>
      <div className="picker">
        <div className="picker-window" />
        {renderYear()}
        {renderMonth()}
        {renderDate()}
        <ul className="picker-hour">
          <li>0</li>
          <li>1</li>
          <li>2</li>
          <li>3</li>
          <li>4</li>
          <li>5</li>
          <li>6</li>
          <li>7</li>
          <li>8</li>
          <li>9</li>
          <li>10</li>
          <li>11</li>
          <li>12</li>
          <li>13</li>
          <li>14</li>
          <li>15</li>
          <li>16</li>
          <li>17</li>
          <li>18</li>
          <li>19</li>
          <li>20</li>
          <li>21</li>
          <li>22</li>
          <li>23</li>
        </ul>
        <ul className="picker-minute">
          <li>00</li>
          <li>05</li>
          <li>10</li>
          <li>15</li>
          <li>20</li>
          <li>25</li>
          <li>30</li>
          <li>35</li>
          <li>40</li>
          <li>45</li>
          <li>50</li>
          <li>55</li>
        </ul>
      </div>
    </InnerScrollPickerStyled>
  )
}

export default React.memo(InnerScrollPicker)
